/**
 * Paper for printing (AP-99): A4 or A3, landscape. app.css sets A4; a style
 * element added last overrides it, so the print dialog opens with the choice.
 */
export type Paper = 'A4' | 'A3';

const KEY = 'pst.print.paper';
const STYLE_ID = 'pst-page-size';

export function storedPaper(): Paper {
  try { return window.localStorage.getItem(KEY) === 'A3' ? 'A3' : 'A4'; } catch { return 'A4'; }
}

export function setPaper(paper: Paper): void {
  try { window.localStorage.setItem(KEY, paper); } catch { /* private window */ }
  let el = document.getElementById(STYLE_ID);
  if (!el) {
    el = document.createElement('style');
    el.id = STYLE_ID;
    document.head.appendChild(el);
  }
  el.textContent = `@page { size: ${paper} landscape; margin: 10mm; }`;
}

/** Sets the paper and opens the print dialog. */
export function printOn(paper: Paper): void {
  setPaper(paper);
  window.print();
}
